import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    padding-top: 1.2em;

    .article-author {
        border-top: .11em solid #000;
        padding: 2.6em 0 3.2em;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .author-image {
            width: 9em;
            height: 9em;
            border-radius: 50%;
            margin-right: 2em;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .author-data {
            max-width: calc(100% - 10em);

            .author-name {
                font-size: 1.25em;
                margin-bottom: .4em;
                font-weight: 600;
            }
            .author-description {
                p {
                    span {
                        font-size: 1.05em!important;
                        line-height: 1.375em!important;
                        font-family: 'Open Sans',sans-serif!important;
                    }
                }
            }
        }
    }
    @media all and (max-width: ${variables.mobileL}) {
        .article-author {
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .author-image {
                margin: 0 auto 1.2em;
                width: 11em;
                height: 11em;
            }
            .author-data {
                max-width: 100%;
                text-align: center;

                .author-name {
                    font-size: 1.5em;
                    margin-bottom: 1.1em;
                }
                .author-description {
                    padding: 0 1em;

                    p {
                        span {
                            font-size: 1.25em!important;
                            line-height: 1.425em!important;
                        }
                    }
                }
            }
        }
    }

`;